import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=a0f11eec&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=a0f11eec&scoped=true&lang=css&"
import style1 from "./Header.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f11eec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0f11eec')) {
      api.createRecord('a0f11eec', component.options)
    } else {
      api.reload('a0f11eec', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=a0f11eec&scoped=true&", function () {
      api.rerender('a0f11eec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/Layout/Header.vue"
export default component.exports